import { ConversationsSdkImpl } from "~/modules/conversations/ConversationsSdkImpl";
import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { ConversationsUser } from "~/modules/conversations";



















export class GetConversationsUser implements Action<Promise<ConversationsUser>> {
    


    #identity: string;

    constructor(identity: string) {
        this.#identity = identity;
    }

    async run(ctx: {}): Promise<ConversationsUser> {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        const conversations = context.retrieveInstanceOf(ContextInstance.ConversationsSdkImpl, ConversationsSdkImpl);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        await taskRouter.init();
        const worker = taskRouter.worker;

        try {
            await conversations.init();
        } catch (error) {
            const errorMsg = `GetConversationsUser: Failed to initialize Conversations SDK`;
            logger.error(errorMsg, error);
            sendTrackingEvent(EVENTS.GetConversationsUserCompleted, analytics, worker, { error: errorMsg });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        try {
            const user = await conversations.getUser(this.#identity);
            sendTrackingEvent(EVENTS.GetConversationsUserCompleted, analytics, worker, { userSid: user.entityName });
            return user;
        } catch (error) {
            const errorMsg = `GetConversationsUser: Failed to get conversations user`;
            logger.error(errorMsg, error);
            sendTrackingEvent(EVENTS.GetConversationsUserCompleted, analytics, worker, { error: errorMsg });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
    }
}
